import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import FileDashboard from "./pages/FileDashboard";
import FunctionPage from "./components/FunctionPage";
import Attachments from "./pages/Attachments";
import PrivateRoute from "./components/PrivateRoute";
import { ToastProvider } from "./lib/toast";

export default function App() {
  return (
    <ToastProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Signup />} />

          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/attachments"
            element={
              <PrivateRoute>
                <Attachments />
              </PrivateRoute>
            }
          />
          <Route
            path="/file/:fileId"
            element={
              <PrivateRoute>
                <FileDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/file/:fileId/function/:functionId"
            element={
              <PrivateRoute>
                <FunctionPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </ToastProvider>
  );
}
